<div
  class="toast-container"
  role="region"
  aria-label="Notifications"
  aria-live="polite"
  aria-relevant="additions"
  aria-atomic="false"
>
  @for (toast of toasts(); track toast.id) {
    <app-toast-item [toast]="toast" />
  }
</div>
